<dialog-draggable-header>Add Files</dialog-draggable-header>

<mat-dialog-content style="overflow: hidden;">
   <mat-spinner *ngIf="uploading;else uploadMenu" class="m-auto"></mat-spinner>
   <ng-template #uploadMenu>
      <p-fileUpload customUpload="true" (uploadHandler)="onUpload($event)" multiple="multiple" maxFileSize="100000000"
         fileLimit="20" invalidFileTypeMessageDetail=""
         accept=".doc,.docx,.dotx,.xls,.xlsx,.xlt,.xltx,.ppt,.pptx,.potx,.pps,.ppsm,.txt,.jpg,.jpeg,.png,.gif,.pdf,.xml,.rtf,.bmp,.snp,.zip,.csv,.des">
         <ng-template pTemplate="content">
            <ul *ngIf="uploadedFiles?.length">
               <li *ngFor="let file of uploadedFiles">{{file.name}} - {{file.size}} bytes</li>
            </ul>
         </ng-template>
      </p-fileUpload>
   </ng-template>
</mat-dialog-content>

<mat-dialog-actions class="mat-dialog-actions-end no-margin">
   <button mat-dialog-close mat-raised-button> Close </button>
</mat-dialog-actions>